import React from "react";
import getPaymentDay from "../misc/get-payment-day";
import { usd } from "../../../utils/utils";
import moment from "moment";
import Show from "../../../utils/show.component";
import { authPaymentTypes } from "../parent/data/auth-payment-types";

export const EditOrCancelContent = (props) => {
  const isFixedAmount = props.loan.RecurringPayment.OpenEndedPaymentType === "Fixed Amount";
  const hasDueDate = props.loan.NextDueDate !== "0001-01-01T00:00:00" ? true : false;

  const isPastDueWithoutCoveringPayment =
    props.loan.AmountPastDue && !props.loan.ScheduledACHPaysPastDue ? true : false;

  const achPaymentTypeValue = 0;
  const lakeTrustAccountPaymentTypeValue = 1;

  const getPaymentInfoMethod = (existingRecurringPayment) => {
    let method = "";
    switch (existingRecurringPayment.TransferType) {
      case (achPaymentTypeValue):
        method = "BankAccount";
        break;
      case (lakeTrustAccountPaymentTypeValue):
        method = "LakeTrustAccount";
        break;
    }
    return method;
  };

  const advanceEdit = () => {
    window.scrollTo(0, 0);
    props.setPaymentInfo((state) => {
      return {
        ...state,
        method: getPaymentInfoMethod(props.loan.RecurringPayment),
        loanId: props.selectedLoanId,
        type: props.paymentType,
        isOpenEnded: props.isOpenEnded,
      };
    });

    props.hideModal();
  };

  const advanceCancel = () => {
    props.setPaymentInfo((state) => {
      return {
        ...state,
        method: getPaymentInfoMethod(props.loan.RecurringPayment),
        loanId: props.selectedLoanId,
        type: authPaymentTypes.valid.RecurringCancellation,
        isOpenEnded: props.isOpenEnded,
      };
    });

    props.hideModal();
  };

  const nextScheduled = moment(props.loan.RecurringPayment.NextScheduledDtTm).format("MM/DD/YYYY");
  // getPaymentDate includes  a prefix of "Every other " in the biweekly return value, so add a replace
  const paymentDateToUse =
    props.loan.RecurringPayment.RecurringPaymentFrequency === "Monthly"
      ? moment.localeData().ordinal(props.loan.RecurringPayment.SelectedDay)
      : getPaymentDay(props.loan.RecurringPayment.RecurringPaymentFrequency, nextScheduled).replace(
          "Every other ",
          ""
        );

  const editButton = (
    <button
      className="w-100 autopay-button-new"
      style={{ color: "white" }}
      onClick={() => advanceEdit()}
    >
      Edit AutoPay
    </button>
  );

  const cancelButton = (
    <button
      className="w-100 autopay-button-cancel"
      style={{ color: "white" }}
      onClick={() => advanceCancel()}
    >
      Cancel All Payments
    </button>
  );
  return (
    <div>
      <div className="f24 bold mb-3">AutoPay Details</div>
      <div className="container-fluid" style={{ textAlign: "start", fontSize: "14px" }}>
        <div class="row mb-4 ">
          <div class="col-7">Payment Frequency</div>
          <div class="col-5 bold text-end ">
            {props.loan.RecurringPayment.RecurringPaymentFrequency}
          </div>
        </div>
        <div class="row mb-4 ">
          <div class="col-7">Payment Day</div>
          <div class="col-5 bold text-end ">{paymentDateToUse}</div>
        </div>
        <div class="row mb-4 ">
          <div class="col-7">Next Payment Date</div>
          <div class="col-5 bold text-end ">
            {moment(props.loan.RecurringPayment.NextScheduledDtTm).format("MM/DD/YYYY")}
          </div>
        </div>
        <div class="row mb-4 ">
          <div class="col-7">Payment Account</div>
          <div class="col-5 bold text-end ">
            { props.loan.RecurringPayment.AccountLastFour ? 
                "Ending in " + props.loan.RecurringPayment.AccountLastFour :
                "..."
            }
          </div>
        </div>
        <Show condition={props.loan.IsOpenEndedLoan && !isFixedAmount}>
          <div class="row mb-4 ">
            <div class="col-6">Payment Method</div>
            <div class="col-6 bold text-end ">
              {props.loan.RecurringPayment.OpenEndedPaymentType.replace(" Due", "")}
            </div>
          </div>
        </Show>
        <Show condition={!props.loan.IsOpenEndedLoan || isFixedAmount}>
          <div class="row mb-4 ">
            <div class="col-7">Payment Amount</div>
            <div class="col-5 bold text-end ">{usd.format(props.loan.RecurringPayment.Amount)}</div>
          </div>
        </Show>
        {/* Hide edit button if the loan is past due without a scheduled ach to cover it, or if there is no next due date */}
        {isPastDueWithoutCoveringPayment || !hasDueDate ? null : editButton}
        {cancelButton}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/modal/edit-or-cancel-content.component.js